import { render } from "./LiveClasses.vue?vue&type=template&id=eb7cd770&scoped=true"
import script from "./LiveClasses.vue?vue&type=script&lang=js"
export * from "./LiveClasses.vue?vue&type=script&lang=js"

import "./LiveClasses.vue?vue&type=style&index=0&id=eb7cd770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7cd770"]])

export default __exports__